import * as Popover from "@radix-ui/react-popover";
import { useState } from "react";
import { LinkEditorPanel } from "../../../panels";
import { Icon } from "../../../ui/Icon";
import { Toolbar } from "../../../ui/Toolbar";

export type EditLinkPopoverProps = {
  onSetLink: (link: string, openInNewTab?: boolean) => void;
};

export const EditLinkPopover = ({ onSetLink }: EditLinkPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSetLink = (link: string, openInNewTab?: boolean) => {
    onSetLink(link, openInNewTab);
    setIsOpen(false); // Close the popover after setting the link
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <Toolbar.Button tooltip="Set Link">
          <Icon name="Link" />
        </Toolbar.Button>
      </Popover.Trigger>
      <Popover.Content className="z-10">
        <LinkEditorPanel onSetLink={handleSetLink} />
      </Popover.Content>
    </Popover.Root>
  );
};
